'use client'

import {useEffect, useState} from "react";
// import {clarity} from "react-microsoft-clarity";
// import {push} from "@socialgouv/matomo-next";
import mixpanel from "mixpanel-browser";
import posthog from "posthog-js";
import {handleScroll} from "~/components/handle-scroll/handle-scroll";
import AppHead from "~/components/head/head";
import FloatingTryForFree from "~/components/floating-try-for-free/floating-try-for-free";
import TopNavBar from "~/components/top-nav-bar/top-nav-bar";
import {navigateToApp} from "~/components/navigate-to-top/navigate-to-top";
import Footer from "~/components/footer/footer";
import {LoaderFunctionArgs} from "react-router";
import {useLoaderData} from "@remix-run/react";
import getAppLinks from "~/components/app-links/app-links";
import {MetaFunction} from "@remix-run/node";

export const loader = async ({
                                 params,
                             }: LoaderFunctionArgs) => {
    console.log('downloads/ started');
    // Get latest Firebase Storage links:
    return getAppLinks();
};


export default function Downloads() {
    const {downloadLinks} = useLoaderData<typeof loader>();
    const [visibleHeader, setVisibleHeader] = useState(false)
    const [prevScrollPos, setPrevScrollPos] = useState(0);


    useEffect(() => {
        // clarity.init('j9gx132pyl');
        // push(["trackEvent", "Downloads Page Open", "downloads"]);
        mixpanel.track('Landing Page Open', {
            "screen": "downloads",
        });
        posthog.capture('Landing Page Open', {screen: 'downloads'})

        window.addEventListener('scroll', () => {
            handleScroll(setVisibleHeader, setPrevScrollPos);
        });
        return () => window.removeEventListener('scroll', () => {
            handleScroll(setVisibleHeader, setPrevScrollPos);
        })
    }, []);

    return (
        <main className={"main-page-bg"}>
            <AppHead/>

            <FloatingTryForFree visibleHeader={visibleHeader}/>

            <section className={"py-4 lg:py-8 "}>
                <TopNavBar/>

                {/*<div className={"flex flex-col md:flex-row mt-10 md:mt-20 w-100 px-20"}>*/}
                {/*    <div className={"flex justify-center text-2xl w-full md:w-3/5 lg:w-1/2 md:pl-7 lg:pl-14 "}>*/}
                {/*        <div className={"mt-10 inline-block align-middle h-auto"}>*/}
                {/*            <h1 className={"text-3xl md:text-4xl lg:text-5xl font-bold"}>*/}
                {/*                Download The Bullish Trade*/}
                {/*            </h1>*/}
                {/*            <p className={"mt-5 text-lg "}>*/}
                {/*                We have options for every platform.*/}
                {/*                <br/>*/}
                {/*                <br/>*/}
                {/*                {"Whether you want to browse the markets on your desktop or on your mobile while on the go, we've got you covered."}*/}
                {/*                <br/>*/}
                {/*                <br/>*/}
                {/*                All our application, whether it is a Desktop software or Mobile app have the same features and functionality. And of course, the sync all the data across your devices automatically.*/}
                {/*                <br/><br/>*/}
                {/*                With The Bullish Trade you have access to the state of the art options scanner on all your devices.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    <div*/}
                {/*        className={"overflow-clip w-full md:w-2/5 lg:w-1/2 mt-10 lg:mt-0 md:rounded-l-xl"}*/}
                {/*        style={{paddingTop: 25}}>*/}
                {/*        <img src={"screenshots/iphone-and-mac-min.png"} alt={"The Bullish Trade on iPhone and Mac"}/>*/}
                {/*    </div>*/}


                {/*</div>*/}
                <div className={"flex flex-col"}>


                    <div className={"px-10 mt-20 order-last lg:order-first"}>
                        <div className={"text-center my-14"}>
                            <h2 className={"mt-10 text-3xl font-bold mb-6"}>🖥️ Desktop Platforms</h2>
                            <div>
                                Get the desktop version for any platform you use:
                            </div>
                        </div>

                        <div className="grid grid-cols-3 gap-4 text-center">
                            <div>
                                <h4 className={"text-2xl font-bold flex justify-center"}>
                                    {/*<img src={"graphics/mac.png"} alt={"MacOS"} className={"h-8 mr-2"}/>*/}
                                    {/*<span className={"mr-5"}>MacOS</span>*/}
                                    MacOS
                                </h4>
                                <div className={"w-20 mt-3 mb-5 mx-auto border-b border-b-white"}></div>
                                <div>
                                    You can either download the MacOS app directly,
                                    <br/>
                                    or get it from the Mac App Store.
                                </div>
                                {/*<div className={"text-sm"}>*/}
                                {/*    Both apps are identical, so you can choose the method that works best for you.*/}
                                {/*</div>*/}


                            </div>

                            <div>
                                <h4 className={"text-2xl font-bold flex justify-center"}>
                                    {/*<img src={"graphics/win.png"} alt={"Windows"} className={"h-8 mr-2"}/>*/}
                                    {/*<span className={"mr-5"}>Windows</span>*/}
                                    Windows
                                </h4>
                                <div className={"w-20 mt-3 mb-5 mx-auto border-b border-b-white"}></div>
                                <div>
                                    Download the Windows installer and run it on
                                    <br/>
                                    your Windows machine:
                                </div>
                            </div>

                            <div>
                                <h4 className={"text-2xl font-bold flex justify-center"}>
                                    {/*<img src={"graphics/linux.png"} alt={"Linux"} className={"h-8 mr-2"}/>*/}
                                    {/*<span className={"mr-5"}>Linux</span>*/}
                                    Linux
                                </h4>
                                <div className={"w-20 mt-3 mb-5 mx-auto border-b border-b-white"}></div>
                                <div>
                                    Download the Linux AppImage and run it on
                                    <br/>
                                    your Linux computer:
                                </div>
                            </div>
                        </div>


                        <div className="grid grid-cols-3 gap-4 text-center mt-10">
                            <div>
                                <div className={"text-center"}>
                                    <img
                                        onClick={() => navigateToApp(
                                            // "https://thebullish.trade/downloads/thebullishtrade.dmg",
                                            downloadLinks.mac,
                                            "macos-download", "macos-download")}
                                        className={"h-14 mt-3 object-contain mx-auto cursor-pointer"}
                                        src={"/macos-dmg.png"} alt={"Download MacOS DMG"}/>
                                </div>

                                <div>
                                    <img
                                        onClick={() => navigateToApp(
                                            "https://apps.apple.com/us/app/the-bullish-trade/id6466982556",
                                            "mac-store", "macstore-app")}
                                        className={"h-14 mt-3 object-contain mx-auto cursor-pointer"}
                                        src={"/macstore.svg"} alt={"Download on the Mac App Store"}/>

                                </div>

                            </div>


                            <div>
                                <img
                                    onClick={() => navigateToApp(
                                        downloadLinks.win,
                                        "windows-download", "windows-download")}
                                    className={"h-14 mt-3 object-contain mx-auto cursor-pointer"}
                                    src={"/windows.svg"} alt={"Download Windows Installer"}/>

                            </div>

                            <div>
                                <img
                                    onClick={() => navigateToApp(
                                        downloadLinks.linux,
                                        "linux-app-image", "linux-app-image")}
                                    className={"h-14 mt-3 object-contain mx-auto cursor-pointer"}
                                    src={"/linux-appimage.png"} alt={"Download Linux AppImage"}/>

                            </div>
                        </div>
                    </div>


                    <div className={"px-10 mt-20 order-first lg:order-last"}>
                        <div className={"w-40 mt-10 mb-20 mx-auto border-b border-b-white"}></div>

                        <div className={"text-center my-14"}>
                            <h2 className={"mt-10 text-3xl font-bold mb-6"}>📱 Mobile Apps</h2>

                            <div>
                                Download The Bullish Trade app for your mobile phone (whether it is iPhone or Android),
                                <br/>
                                and browse the options markets wherever you are.
                            </div>
                        </div>


                        <div className="grid grid-cols-2 gap-4 text-center">
                            <div>
                                <h4 className={"text-2xl font-bold"}>iOS</h4>
                                <div className={"w-20 mt-2 mb-5 mx-auto border-b border-b-white"}></div>
                                <div>
                                    Get The Bullish Trade app for your iPhone or iPad
                                    <br/>
                                    from the App Store:
                                </div>
                            </div>
                            <div>
                                <h4 className={"text-2xl font-bold"}>Android</h4>
                                <div className={"w-20 mt-2 mb-5 mx-auto border-b border-b-lime-500"}></div>
                                <div>
                                    Download Android app from the
                                    <br/>
                                    Google Play Store:
                                </div>
                            </div>
                        </div>


                        <div className="grid grid-cols-2 gap-4 text-center mt-10">
                            <div>

                                <img
                                    onClick={() => navigateToApp(
                                        "https://apps.apple.com/us/app/the-bullish-trade/id6466982556",
                                        "app-store", "ios-app")}
                                    className={"h-14 mt-3 object-contain mx-auto cursor-pointer"}
                                    src={"/appstore.svg"} alt={"Download on the App Store"}/>
                            </div>

                            <div>
                                <img
                                    onClick={() => navigateToApp(
                                        "https://play.google.com/store/apps/details?id=trade.thebullish.app&pli=1&utm_source=the_bullish_landing&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
                                        "play-store", "android-app")}
                                    className={"h-20 cursor-pointer object-contain mx-auto cursor-pointer"}
                                    alt='Get it on Google Play'
                                    src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                            </div>
                        </div>
                    </div>
                </div>


                <div className={"px-10 mt-20 order-first lg:order-last"}>
                    <div className={"w-40 mt-10 mb-20 mx-auto border-b border-b-white"}></div>

                    <div className={"text-center my-14"}>
                        <h2 className={"mt-10 text-3xl font-bold mb-6"}>🌎 Web App</h2>

                        <div>
                            You can always access your Bullish Trade account from any device with a web browser as well.
                            <br/>
                            <br/>
                            Just open the next URL:
                        </div>
                        <div className={"mt-10"}>
                            <span onClick={() => navigateToApp("https://app.thebullish.trade", "app", "mid-signup-free")}
                              className={"cursor-pointer bg-green-700 text-white px-8 py-4 text-xl font-bold rounded-xl"}>http://app.thebullish.trade</span>
                        </div>
                    </div>
                </div>
                <div className={"h-20"}></div>
            </section>
            <Footer/>
        </main>

    );
}



export const meta: MetaFunction = () => {
    return [
        {title: "Downloads | The Bullish Trade"},
        {
            property: "og:title",
            content: "Downloads | The Bullish Trade",
        },
        {
            property: "twitter:title",
            content: "Downloads | The Bullish Trade",
        },
        {
            name: "description",
            content: "Download The Bullish Trade - Options trader's secret toolkit",
        },
        {
            property: "og:type",
            content: "website",
        },
        {
            property: "og:url",
            content: "https://thebullish.trade",
        },
        {
            property: "og:description",
            content: "Download The Bullish Trade - Options trader's secret toolkit",
        },
        {
            property: "twitter:description",
            content: "Download The Bullish Trade - Options trader's secret toolkit",
        },
        {
            property: "og:image",
            content: "https://thebullish.trade/graphics/1024.jpg",
        },
        {
            property: "twitter:image",
            content: "https://thebullish.trade/graphics/1024.jpg",
        },
        {
            property: "twitter:card",
            content: "summary_large_image",
        },
        {
            property: "twitter:url",
            content: "https://thebullish.trade",
        },
    ];
};